// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  ListRecentTimesheetFieldOptionsRequest,
  ListRecentTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListRecentTimesheetFieldOptionsRpc = (request: ListRecentTimesheetFieldOptionsRequest) => Observable<ListRecentTimesheetFieldOptionsResponse>

export const listRecentTimesheetFieldOptions = (listRecentTimesheetFieldOptionsRpc: ListRecentTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listRecentTimesheetFieldOptions.match),
      mergeMap((action) => of(action.payload)
        .pipe(
          mergeMap(listRecentTimesheetFieldOptionsRpc),
          map(response => ({ siteId: action.payload.getSiteId(), options: response.toObject().timesheetFieldOptionsList })),
          map(Slice.setRecentTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_recent_timesheet_field_options_failed",
              message: "Failed to load recent timesheet field options. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )),
    )

const listRecentTimesheetFieldOptionsRpc = (request: ListRecentTimesheetFieldOptionsRequest): Observable<ListRecentTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.listRecentTimesheetFieldOptions(request, null))

export default listRecentTimesheetFieldOptions(listRecentTimesheetFieldOptionsRpc)
